import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";
import Section from "../../../utility/ui-components/section";
import Container from "../../../utility/ui-components/container";
import home from "../../../../common/assets/data/home";
import SectionHeading from "../../../utility/ui-components/sectionHeading";
import ScrollAnimation from "react-animate-on-scroll";

function FAQSection() {
  const data = home.FAQSection;
  return (
    <Section className={"bg-gray-light"}>
      <Container>
      <ScrollAnimation  animateIn="animate__fadeIn">
        <SectionHeading heading={data.Heading} />
      </ScrollAnimation>
        <Accordion className="lg:grid lg:grid-cols-2 gap-4 items-start" allowZeroExpanded={true} allowMultipleExpanded={false}>
          {data.Questions.map((faq, index) => (
            <AccordionItem key={index + 1} className="shadow-lg ">
              <AccordionItemHeading>
                <AccordionItemButton className="p-3 text-base mb-2 md:text-lg font-bold capitalize">
                  {faq.Question}
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <p className="text-base p-4">{faq.Answer}</p>
              </AccordionItemPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </Container>
    </Section>
  );
}

export default FAQSection;
